import React from 'react';
import PropTypes from 'prop-types';

/** renders a form title */
var FormTitle = function FormTitle(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("h3", {
    className: "form-title ".concat(className || '')
  }, children);
};
FormTitle.displayName = "FormTitle";
FormTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export { FormTitle };